<template>
  <div id="smooth-wrapper">
    <div id="smooth-content">
      <ContentRenderer v-if="page" :value="page" />
      
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'
import { loadGsap } from '@/utils/gsap'

const smoother = ref<any>(null)

const route = useRoute()

const { data: page } = await useAsyncData(route.path, () => {
  return queryCollection('pages').path(route.path).first()
})

onMounted(async () => {
  
    
  
})

onUnmounted(() => {
  
})
useContentSeo(page)
</script>
